<template>
  <div>
    <h5 class="text-center text-color-red" v-show="allow_above_medication_text">
      {{ translatedFields['above_please_tell_us_more_about_yourself'] }}
    </h5>
    <h5 class="text-center">
      {{ translatedFields['please_tell_us_more_about_yourself'] }}
    </h5>
    <!-- <div class="row">
      <div class="form-group">
        <div v-if="!model.kit_number" class="col-md-10 col-md-offset-1">
          <el-button icon="el-icon-camera-solid" class="w-100 scan-button" @click="drawer=true"><span>Scan Barcode on Tube</span></el-button>
          <el-drawer
            :with-header="false"
            :append-to-body="true"
            :visible.sync="drawer"
            direction="ltr"
            size="100%"
          >
            <HomekitScanner v-on:closeScanner="closeScanner" v-on:getScannedData="getScannedData"/>
          </el-drawer>
        </div>
        <div v-else class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <label class="control-label required">
              {{ translatedFields['kit_number'] }}
            </label>
            <input class="form-control"
                  type="text"
                  data-vv-as="Kit Number"
                  name="kit_number"
                  v-validate="modelValidations.kit_number"
                  v-model="model.kit_number"
                  placeholder="888 888"
            />
          </div>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="form-group">
        <small class="text-danger col-md-10 col-md-offset-1" v-show="errorKit">
          {{ errorKit }}
        </small>
      </div>
    </div>
    <!-- first name / last name-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['first_name'] }}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="First Name"
                 name="firstName"
                 v-validate="modelValidations.firstName"
                 v-model="model.firstName"
                 placeholder="ex: Mike"
          />
          <small class="text-danger" v-show="firstName.invalid">
            {{ getError('firstName', 'First') }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['last_name'] }}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="Last Name"
                 name="lastName"
                 v-validate="modelValidations.lastName"
                 v-model="model.lastName"
                 placeholder="ex: Andrew"
          />
          <small class="text-danger" v-show="lastName.invalid">
            {{ getError('lastName') }}
          </small>
        </div>
      </div>
    </div>
    <!--    email-->
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label :class="((this.$store.state.site.notify_patient === '3') || (this.$store.state.site.notify_patient === '4') || (this.$store.state.site.notify_patient === null)) ? 'required' : '' " class="control-label">
            {{ translatedFields['email'] }}
          </label>
          <input type="email"
                 name="email"
                 ref="email"
                 data-vv-as="Email"
                 v-validate="((this.$store.state.site.notify_patient === '3') || (this.$store.state.site.notify_patient === '4') || (this.$store.state.site.notify_patient === null )) ? modelValidations.email : ''"
                 v-model="model.email"
                 class="form-control">
          <small class="text-danger" v-show="email.invalid">
            {{ getError('email') }}
          </small>
        </div>
      </div>
    </div>
    <!--  confirmation  email-->
    <div v-if="double_entry_email" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label :class="((this.$store.state.site.notify_patient === '3') || (this.$store.state.site.notify_patient === '4') || (this.$store.state.site.notify_patient === null)) ? 'required' : '' " class="control-label">
            {{ translatedFields['confirmation_email'] }}
          </label>
          <input type="email"
                 data-vv-as="Confirmation Email"
                 @paste.prevent
                 name="confirmation_email"
                 v-validate="'confirmed:email'"
                 v-model="model.confirmation_email"
                 class="form-control">
          <small class="text-danger" v-show="confirmation_email.invalid">
            {{ getError('confirmation_email') }}
          </small>
        </div>
      </div>
    </div>
    <!--    address gender -->
    
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <Address id="patient" @updateAddress="updateAddress" :componentsInsurance="model.addressComponents" wizardStep="medical" />
        <small class="text-danger" v-if="address_error" v-text="address_error">
          {{ address_error }}
        </small>
      </div>
    </div>
    <!--GENDER-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['gender'] }}
          </label>
          <el-select size="large"
                     data-vv-as="Gender"
                     v-validate="modelValidations.gender"
                     placeholder="Single Select"
                     name="gender"
                     v-model="model.gender">
              <el-option v-for="option in this.$store.state.gender"
                         class="select-danger"
                         :value="option.name"
                         :label="option.name"
                         :key="option.name">
              </el-option>
          </el-select>
          <small class="text-danger" v-show="gender.invalid">
            {{ getError('gender') }}
          </small>
        </div>
      </div>

      <!--RACE-->
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['race'] }}
          </label>
          <el-select size="large"
                     data-vv-as="Race"
                     v-validate="modelValidations.race"
                     placeholder="Single Select"
                     name="race"
                     v-model="model.race">
              <el-option v-for="option in this.$store.state.race"
                         class="select-danger"
                         :value="option.name"
                         :label="option.name"
                         :key="option.name">
              </el-option>
          </el-select>
          <small class="text-danger" v-show="race.invalid">
            {{ getError('race') }}
          </small>
        </div>
      </div>
    </div>
    <!--ETHNICITY-->
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['ethnicity'] }}
          </label>
          <el-select size="large"
                    data-vv-as="Ethnicity"
                    v-validate="modelValidations.ethnicity"
                    placeholder="Single Select"
                    name="ethnicity"
                    v-model="model.ethnicity">
              <el-option v-for="option in this.$store.state.ethnicity"
                        class="select-danger"
                        :value="option.name"
                        :label="option.name"
                        :key="option.name">
              </el-option>
          </el-select>
          <small class="text-danger" v-show="ethnicity.invalid">
            {{ getError('ethnicity') }}
          </small>
        </div>
      </div>
    </div>
    <!-- dob phone-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['date_of_birth'] }}
          </label>
          <input class="form-control date-cleave-format"
                 type="text"
                 name="dob_pretty"
                 v-model="model.dob_pretty"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 @change="validateDate($event.target.value)"
                 placeholder="ex: 12/22/1980"
                 maxlength="10"
          />
          <small class="text-danger" v-if="errorDate" v-text="errorDate">
            {{ errorDate }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['phone'] }}
          </label>
          <input class="form-control phone-cleave-format"
                 type="text"
                 data-vv-as="Phone"
                 name="phone"
                 v-validate="modelValidations.phone"
                 v-model="model.phone"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 placeholder="ex: (954) 000-0000"
                 maxlength="14"
          />
          <small class="text-danger" v-show="phone.invalid">
            {{ getError('phone') }}
          </small>
        </div>
      </div>
    </div>
    <!--Questions-->
    <h5 class="text-center"> {{ translatedFields['please_answer_to_the_best_of_your_knowledge'] }} </h5>
    <div class="row question" v-if="registrationQuestionsValidation(question)" v-for="question in this.$store.state.questions" :key="question.id" :id="'question_' + question.id">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <div class="row">
            <div class="col-md-7">
              <label v-if="$store.state.lang.value === 'ES' && question.name_es" class="control-label required">
                {{question.name_es}}
              </label>
              <label v-else-if="$store.state.lang.value === 'ZH' && question.name_zh" class="control-label required">
                {{question.name_zh}}
              </label>
              <label v-else class="control-label required">
                {{question.name}}
              </label>
            </div>
            <div class="col-md-5">
              <div v-if="question.answer_type === 'Combobox'">
                <el-select size="large"
                          name="question.answer"
                          placeholder="Select Answer"
                          @change="registrationQuestionsFormatter(question)"
                          v-validate="modelValidations.generic_question"
                          v-model="question.answer">
                  <el-option v-for="option in getAnswers(question)"
                            class="select-danger"
                            :value="option"
                            :label="translateToSpanish(option)"
                            :key="option">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <input v-if="question.answer && question.answer.toUpperCase().includes('PLEASE SPECIFY')" class="form-control"
                type="text" :placeholder="question.name"
                name="generic_answer"
                v-validate="modelValidations.generic_answer"
                v-model="question.answer_other"
        />
        <small class="text-danger" v-show="question.answer === undefined">
          {{ translatedFields['answer_required'] }}
        </small>
        <small class="text-danger" v-show="(question.answer_type === 'Combobox' && question.answer && question.answer.toUpperCase().includes('PLEASE SPECIFY') ) && (question.answer_other === undefined || question.answer_other === '')">
          {{ translatedFields['answer_required'] }}
        </small>
        <input v-if="question.answer_type !== 'Combobox' && question.answer_type !== 'Date'" class="form-control"
                type="text"
                name="answer"
                v-validate="modelValidations.generic_question"
                v-model="question.answer"
        />
        <input v-if="question.answer_type === 'Date'" class="form-control date-question-cleave-format"
                type="text"
                name="answer_pretty"
                v-model="question.answer_pretty"
                v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                @change="validateQuestionDate($event.target.value, question)"
                maxlength="10"
                placeholder="Please specify the date"
        />
        <small class="text-danger" v-model="questionErrorDate[question.id]" v-if="questionErrorDate[question.id]" v-text="questionErrorDate[question.id]">
          {{ questionErrorDate[question.id] }}
        </small>
        <hr>
      </div>
    </div>
    <!-- Payment -->
    <div v-if="allow_payment && paymentMethod === 'card' && this.model.smart_pay == 'cash' && this.$store.state.billingType=='card'" class="row">
      <div class="col-md-11 col-md-offset-1 margin">
        <card />
      </div>
    </div>

    <div v-if="allow_payment && paymentMethod === 'card' && this.model.smart_pay == 'cash' && this.$store.state.billingType=='card'" class="row">
      <div class="col-md-10 col-md-offset-1">
        
      </div>
    </div>

  <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="d-flex">
          <p-checkbox v-model="model.agreed" name="agreed"
                      v-validate="modelValidations.agreed"
          ></p-checkbox>
          <div>
            By Registering here you agree with our <span @click="openDisclaimer" class="htrx-primary underline c-pointer"> Disclaimer </span>
          </div>
        </div>
        <small class="text-danger" v-show="errorAgreed">
          {{ errorAgreed }}
        </small>
      </div>
      <el-dialog
        title="Disclaimer"
        :visible.sync="drawerDisclaimer"
        width="80%"
        append-to-body
        center>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-check" @click="drawerDisclaimer = false">I understand</el-button>
        </span>
        <p v-html=disclaimer_text></p>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, Autocomplete, Drawer, Button, Dialog} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import Cleave from 'cleave.js'
  import Card from './Card.vue'
  import Address from './Address'
  // import HomekitScanner from './dynamosoft/HomekitScanner'
  require('cleave.js/dist/addons/cleave-phone.us')
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [Dialog.name]: Dialog,
      Card,
      Address
      // HomekitScanner
    },
    mixins: [FormatterUtils, ValidationUtils],
    data () {
      return {
        address_error: '',
        errorMessage: '',
        amount: process.env.PAYMENT_AMOUNT,
        paymentMethod: this.$store.state.billingType,
        drawerDisclaimer: false,
        errorKit: '',
        errorAgreed: '',
        drawer: false,
        force_valid_address: process.env.FORCE_VALID_ADDRESS === 'true',
        double_entry_email: process.env.DOUBLE_ENTRY_EMAIL,
        suggestions: [],
        smartystreets_key: process.env.SMARTYSTREETS_KEY,
        apply_cdc_question_formatter: String(process.env.APPLY_CDC_QUESTION_FORMATTER) === 'true',
        symptomatic_question_name: process.env.SYMPTOMATIC_QUESTION_NAME || 'Symptomatic',
        symptomatic_onset_question_name: process.env.SYMPTOMATIC_ONSET_QUESTION_NAME || 'Symptom Onset',
        allow_payment: String(process.env.ALLOW_PAYMENT) === 'true',
        answers_es: {},
        answers_zh: {},
        errorDate: '',
        questionErrorDate: [],
        answer_no: 'No',
        isEmailForTesting: false,
        allow_above_medication_text: String(process.env.ALLOW_ABOVE_MEDICATION_TEXT) === 'true',
        fields_en: {
          after_registration_you_will_be_redirected_to_a_payment_page: 'After registration you will be redirected to a payment page',
          // kit_number: 'Kit Number',
          first_name: 'First Name',
          address: 'Address',
          address2: 'Address 2',
          last_name: 'Last Name',
          email: 'Email',
          confirmation_email: 'Confirmation Email',
          ethnicity: 'Ethnicity',
          gender: 'Gender',
          phone: 'Phone',
          race: 'Race',
          date_of_birth: 'Date Of Birth',
          please_answer_to_the_best_of_your_knowledge: 'Please answer to the best of your knowledge',
          above_please_tell_us_more_about_yourself: 'The new Federal Mandate for Covid Testing requires ALL patient info to be accurate. Incorrect patient info may delay results or result in the sample being rejected.',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required'
        },
        translatedFields: '',
        model: {
          agreed: false,
          firstName: '',
          lastName: '',
          dob: '',
          dob_pretty: '',
          email: '',
          confirmation_email: '',
          address: '',
          address2: '',
          gender: '',
          phone: '',
          present_medical: '',
          past_medical: '',
          // kit_number: '',
          homekit: true,
          primary_insurance: 'CLIENT BILL',
          ethnicity: '',
          race: '',
          questions: this.$store.state.questions,
          smart_pay: 'cash',
          created_from: 'homekit',
          paid: 0,
          amount_paid: 0,
          addressComponents: '',
          transaction_id: ''
        },
        modelValidations: {
          agreed: {
            required: true
          },
          firstName: {
            min: 2,
            required: true
          },
          lastName: {
            min: 2,
            required: true
          },
          // dob: {
          //   required: true,
          //   date_format: ' este mm-dd-yyyy',
          //   // eslint-disable-next-line
          //   regex: /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/
          // },
          email: {
            required: true,
            email: true
          },
          confirmation_email: {
            required: true
          },
          address: {
            min: 5,
            required: true
          },
          gender: {
            required: true
          },
          phone: {
            required: true,
            min: 14,
            regex: '^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})(?:\\s*(?:#|x\\.?|ext\\.?|extension)\\s*(\\d+))?$'
          },
          primary_insurance: {
            min: 5,
            required: true
          },
          present_medical: {
            min: 5,
            required: true
          },
          past_medical: {
            min: 5,
            required: true
          },
          // kit_number: {
          //   required: true
          // },
          ethnicity: {
            required: true
          },
          race: {
            required: true
          },
          generic_question: {
            required: true
          },
          generic_answer: {
            required: true
          }
        },
        address_smartystreets_selected: {
          invalid: false,
          error_message: 'Looks like we don\'t know this address, please make sure the address is correct',
          first_result: ''
        }
      }
    },
    methods: {
      errorHandler (event) {
        this.errorMessage = event.error ? event.error.message : ''
      },
      openDisclaimer () {
        this.drawerDisclaimer = true
      },
      // getScannedData (data) {
      //   console.log(data)
      //   this.drawer = false
      //   this.model.kit_number = data
      // },
      closeScanner () {
        this.drawer = false
      },
      lookup (queryString, cb) {
        if (queryString) {
          axios
          .get('https://us-autocomplete-pro.api.smartystreets.com/lookup?key=' + this.smartystreets_key + '&search=' + queryString + '&max_results=5')
          .then(response => {
            this.suggestions = []
            var arr = []
            if (response.data.suggestions) {
              response.data.suggestions.forEach((suggestion) => {
                arr.push({
                  value: suggestion.street_line + ', ' + suggestion.city + ', ' + suggestion.state + ' ' + suggestion.zipcode
                })
              })
              let links = arr
              let results = queryString ? links.filter(this.createFilter(queryString)) : links
              if (results.length === 1) {
                this.address_smartystreets_selected.first_result = results[0].value
              }
              // call callback function to return suggestions
              cb(results)
            } else {
              let error = []
              let links = error
              let results = queryString ? links.filter(this.createFilter(queryString)) : links
              cb(results)
            }
          })
          .catch(error => {
            console.log(error)
            // this.userMessage('Error getting bill fields: ' + error.message, 'error');
          })
        }
      },
      updateAddress (data) {
        this.model.addressComponents = data
        this.address_error = ''
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      hidePregnantQuestionIfGenderIsMale () {
        if (typeof this.model.gender !== 'undefined') {
          if (typeof this.$store.state.questions !== 'undefined' && this.$store.state.questions.length) {
            for (let question = 0; question < this.$store.state.questions.length; question++) {
              let questionName = this.$store.state.questions[question]['name'].toLowerCase()
              if (questionName.indexOf('pregnant') >= 0) {
                if (this.model.gender === 'M' || this.model.gender === 'Male') {
                  document.getElementById('question_' + this.$store.state.questions[question]['id']).classList.add('display-none')
                  this.$store.state.questions[question].answer = 'No'
                } else {
                  document.getElementById('question_' + this.$store.state.questions[question]['id']).classList.remove('display-none')
                  this.$store.state.questions[question].answer = ''
                }
              }
            }
          }
        }
      },
      showAddressSmartystreetsError () {
        this.address_smartystreets_selected.invalid = true
        this.errors.add({ // to do
          field: 'address',
          msg: this.address_smartystreets_selected.error_message
        })
      },
      hideAddressSmartystreetsError () {
        this.address_smartystreets_selected.invalid = false
        this.errors.remove({
          field: 'address'
        })
      },
      handleAddressBlur (item) {
        let showAddressSmartystreetsError = true
        if (typeof item.target !== 'undefined' && item.target.value !== 'undefined') {
          if (this.address_smartystreets_selected.first_result !== '' &&
                  this.address_smartystreets_selected.first_result.toLowerCase().indexOf(item.target.value.toLowerCase()) === 0) {
            showAddressSmartystreetsError = false
            item.target.value = this.address_smartystreets_selected.first_result
          }
        }
        if (showAddressSmartystreetsError === true) {
          this.showAddressSmartystreetsError()
        }

        this.$on('input', function () {
          this.hideAddressSmartystreetsError()
        })
      },
      handleAddressSelect (item) {
        this.$emit('input', item.value)
      },
      getAnswers (question) {
        let answersEs
        let answersEn
        let answersZh
        if (question.answers) {
          answersEn = question.answers.split(',')
        }
        if (question.answers_es) {
          answersEs = question.answers_es.split(',')
          answersEs.forEach((element, index) => {
            this.answers_es[answersEn[index]] = answersEs[index]
          })
        }
        if (question.answers_zh) {
          answersZh = question.answers_zh.split(',')
          answersZh.forEach((element, index) => {
            this.answers_zh[answersEn[index]] = answersZh[index]
          })
        }
        return answersEn
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      paymentSuccessful () {
        this.$emit('paymentSuccessful')
      },
      async validate () {
        // if (!this.model.kit_number) {
        //   this.errorKit = 'Please scan the Kit Number'
        // }
        if (!this.model.agreed) {
          this.errorAgreed = 'Please Agree'
        }
        if (!this.model.dob) {
          this.errorDate = 'Date Of Birth field is required'
        } else if (this.isFutureDate(this.model.dob_pretty)) {
          this.errorDate = 'Date Of Birth should not be in the future'
        } else if (!this.errorDate.includes('must be valid')) {
          this.errorDate = ''
        }
        for (let q = 0; q < this.$store.state.questions.length; q++) {
          if ((this.$store.state.questions[q].answer_pretty !== undefined &&
                  (this.$store.state.questions[q].answer === ' ' ||
                  this.$store.state.questions[q].answer === undefined)) ||
             (this.$store.state.questions[q].answer_pretty === undefined &&
                  this.$store.state.questions[q].answer === undefined &&
                  this.$store.state.questions[(q - 1)].answer.toLowerCase() === 'yes')) {
            return false
          }
        }
        this.address_error = ''
        if (!this.model.addressComponents) {
          this.address_error = 'All the fields are required'
          return false
        }
        for (var o in this.model.addressComponents) {
          if (!this.model.addressComponents[o] && o !== 'county_fips' && o !== 'plus4_code') {
            this.address_error = 'All the fields are required'
            return false
          }
        }
        let isAddressValid = false
        if (this.force_valid_address && !this.address_smartystreets_selected.invalid) {
          isAddressValid = true
        }
        if (!this.force_valid_address) {
          isAddressValid = true
        }
        // add this to the if clause 'this.errorKit === '' &&' if barcode scanner needs to be reactivated
        if ((await this.$validator.validateAll() === true) && this.errorDate === '' && this.errorAgreed === '' && isAddressValid) {
          return true
        } else {
          return false
        }
      },
      switchCashPayment () {
        this.$store.state.cashPayment = ''
        if (this.paymentMethod === 'card') {
          this.$store.state.cashPayment = 'card'
        }
      },
      translateToSpanish (option) {
        if (this.$store.state.lang.value === 'ES' && this.answers_es) {
          return this.answers_es[option]
        } else {
          if (this.$store.state.lang.value === 'ZH' && this.answers_zh) {
            return this.answers_zh[option]
          } else {
            return option
          }
        }
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      checkIfPaid () {
        if (this.$store.state.billingType && this.$store.state.cashPayment) {
          return this.$store.state
        }
      },
      paid () {
        return this.$store.state.paid
      },
      disclaimer_text () {
        if (this.$store.state.site.patient_disclaimer) {
          let text
          if (this.$store.state.lang.value === 'ES' && this.$store.state.site.patient_disclaimer_es) {
            text = this.$store.state.site.patient_disclaimer_es
          } else {
            if (this.$store.state.lang.value === 'ZH' && this.$store.state.site.patient_disclaimer_zh) {
              text = this.$store.state.site.patient_disclaimer_zh
            } else {
              if (this.$store.state.lang.value === 'EN' && this.$store.state.site.patient_disclaimer) {
                text = this.$store.state.site.patient_disclaimer
              }
            }
          }
          let linksArray = text.match(/<a href="(.*?)">/g)
          if (linksArray) {
            for (let i = 0; i < linksArray.length; i++) {
                // if doesn't have target already put it
              if (!linksArray[i].includes('target="_blank')) {
                // controll if link has protocol if yes just add target
                if (linksArray[i].includes('http') || linksArray[i].includes('https') || linksArray[i].includes('href="//')) {
                  let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('>')) + ' target="_blank"' + linksArray[i].slice(linksArray[i].indexOf('>'))
                  text = text.replace(linksArray[i], toReturn)
                  // if it doesn't have protocol add // so it wont redirect to localhost/www.userlink.com
                } else {
                  let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('href="') + 6) + '//' + linksArray[i].slice(9)
                  text = text.replace(linksArray[i], toReturn)
                }
              }
            }
          }
          text = 'I authorize HealthTrackRx to disclose limited protected health information (PHI), specifically COVID 19 Test results, to ' +
                  this.$store.state.site.name +
                  '.  I understand that I have the right to revoke this authorization, in writing, at any time. I understand that a revocation is not effective to the extent that any person or entity has already acted in reliance on my authorization.  I understand that my treatment, payment, enrollment, or eligibility for benefits will not be conditioned on whether I sign this authorization.<br><br>' +
                  text
          return text
        }
      },
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      questionsDateValidation () {
        return this.$store.state.questions
      },
      ...mapFields(['firstName', 'lastName', 'email', 'address', 'gender', 'race', 'ethnicity', 'dob', 'phone', 'questions', 'confirmation_email', 'smart_pay'])
    },
    watch: {
      checkIfPaid () {
        this.model.paymentMethod = this.$store.state.billingType
      },
      language () {
        this.checkLanguage()
      },
      // 'model.kit_number': {
      //   handler: function (after, before) {
      //     if (!this.model.kit_number) {
      //       this.errorKit = 'Please scan the Kit Number'
      //     } else {
      //       this.errorKit = ''
      //     }
      //   },
      //   deep: true
      // },
      'model.agreed': {
        handler: function (after, before) {
          if (!this.model.agreed) {
            this.errorAgreed = 'Please Agree'
          } else {
            this.errorAgreed = ''
          }
        },
        deep: true
      },
      'model.gender': {
        handler: function (after, before) {
          this.hidePregnantQuestionIfGenderIsMale()
        },
        deep: true
      },
      'model.dob_pretty': {
        handler: function (dobValue) {
          let dateCleave = new Cleave('.date-cleave-format', {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'd', 'Y']
          })
          this.model.dob_pretty = dateCleave.getFormattedValue()
          if (dobValue.length === 10) {
            let dateParts = dobValue.split('/')
            this.model.dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
          }
        },
        deep: true
      },
      'model.phone': {
        handler: function (after, before) {
          let phoneCleave = new Cleave('.phone-cleave-format', {
            numericOnly: true,
            delimiters: ['(', ')', ' ', '-'],
            blocks: [0, 3, 0, 3, 4]
          })
          this.model.phone = phoneCleave.getFormattedValue()
        },
        deep: true
      },
      questionsDateValidation: {
        immediate: true,
        handler: function (questions) {
          for (let q = 0; q < this.$store.state.questions.length; q++) {
            if (typeof this.$store.state.questions[q].answer_pretty !== 'undefined') {
              let dateCleave = new Cleave('.date-question-cleave-format', {
                date: true,
                delimiter: '/',
                datePattern: ['m', 'd', 'Y']
              })
              this.$store.state.questions[q].answer_pretty = dateCleave.getFormattedValue()
              if (this.$store.state.questions[q].answer_pretty.length === 10) {
                let dateParts = this.$store.state.questions[q].answer_pretty.split('/')
                this.$store.state.questions[q].answer = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
              }
            }
          }
        },
        deep: true
      }
    }
  }
</script>
<style scoped>

>>> .el-select--large{
      width: 100%;
    }

>>> .el-autocomplete{
      width: 100%;
    }

  .required:after {
    content:" *";
    color: red;
  }

  h5{
    margin-bottom: 25px;
  }

  .display-none {
    display: none;
  }

  .text-color-red {
    color: red;
  }

  .htrx-primary{
    color: #f4c617;
  }

  .generic-answer {
    margin-top: 10px;
  }

  .w-100{
    width: 100%;
  }

  .scan-button{
    font-size: 17px;
    color: #f4c617;
    background: white;
    border: 1px solid #f4c617;
    border-radius: 5px;
  }

  .underline{
    text-decoration: underline;
  }

  .d-flex{
    display: flex;
  }

  .checkbox{
    margin-top: 0;
  }

  .c-pointer{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Homekit/Wizard/HomekitRegistration.vue